const tableCellServiceType = {
  Typography: '¿Realmente desea eliminar este elemento?'
};

export default tableCellServiceType;
